import API from '../.';
const ENTITY = 'burocredito';

export const getStatus = (proposalUUID) =>
    API.get(`/api/v1/${ENTITY}/customer/${proposalUUID}/`);
export const save = (data) => API.post(`/api/v1/${ENTITY}/solicitude/`, data);
